/*
 * @Author: Ximen
 * @Date: 2021-03-18 15:57:31
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-14 11:21:08
 */
import * as CryptoJS from 'crypto-js';
import environment from './environment';
import '@/untils/statement/type';

function topSign(params: TNumberString) {
  let str = environment.secret;
  console.log(JSON.stringify(params));
  let keys = Object.keys(params);
  keys = keys.sort();
  keys.forEach((key) => {
    if (params[key] !== '') {
      str += `${key}=${encodeURIComponent(params[key])
        .replace(/%20/g, '+')
        .replace(/!/g, '%21')
        .replace(/~/g, '%7E')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/'/g, '%27')}&`;
    }
  });
  str = str.slice(0, -1) + environment.secret;
  console.log(str);
  console.log(keys);
  return {
    signString: CryptoJS.SHA1(str)
      .toString()
      .toUpperCase(),
    keys,
    str,
  };
}

export default topSign;
